export const formatAddress = (address: string, startChars = 6, endChars = 4) =>
	`${address.slice(0, startChars)}...${address.slice(-endChars)}`

export const formatPrice = (price: number) => `${(price * 100).toFixed(0)}¢`

export const formatCurrency = (value: number, decimals = 2) => `$${value.toFixed(decimals)}`

export const formatVolume = (volume: number) => {
	if (volume >= 1_000_000_000) {
		return `$${(volume / 1_000_000_000).toFixed(2)}B`
	}
	if (volume >= 1_000_000) {
		return `$${(volume / 1_000_000).toFixed(2)}M`
	}
	if (volume >= 1_000) {
		return `$${(volume / 1_000).toFixed(1)}K`
	}
	return `$${volume.toFixed(0)}`
}

export const formatMarketCap = (value: number) => {
	if (value >= 1_000_000_000_000) {
		return `$${(value / 1_000_000_000_000).toFixed(2)}T`
	}
	if (value >= 1_000_000_000) {
		return `$${(value / 1_000_000_000).toFixed(2)}B`
	}
	if (value >= 1_000_000) {
		return `$${(value / 1_000_000).toFixed(2)}M`
	}
	return `$${value.toFixed(0)}`
}

export const formatLiquidity = formatVolume // Same formatting

export const formatPercentage = (value: number, decimals = 1) => `${value.toFixed(decimals)}%`

export const formatShares = (shares: number, decimals = 2) => shares.toFixed(decimals)
